import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "../api/axios";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const AboutDetail = () => {
   const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [about_data, setAboutData] = useState({});
  const history = useHistory();

  const fetchAbout = () => {
    api
      .post(`/about/get`) // 👈 your API endpoint
      .then((response) => {
        if (response.data.about) {
          setAboutData(response.data.about); // Store product data
        } else {
          setAboutData([]);
        }
      })
      .catch((err) => {
        // setError(err.message);
        // setLoading(false);
      });
  };
  useEffect(() => {
    if (about_data) {
      setFormData({
        name: about_data.name || "",
        description: about_data.description || "",
      });
    }
  }, [about_data]);
  useEffect(() => {
    fetchAbout();
  }, []); // Dependencies

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    image: "",
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  // handle input changes
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // handle image file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImage(e.target.files[0]);
    if (file) {
      setPreview(URL.createObjectURL(file)); // create temporary image URL
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("description", formData.description);
      if (image) data.append("image", image);

      // Add _method for Laravel PUT
      if (about_data?.id) data.append("_method", "POST");

      const url = about_data?.id
        ? `/about/update/${about_data.id}`
        : "/about/create";

      const response = await api.post(url, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        const successMessage = about_data?.id
          ? " About info updated successfully!"
          : " About info added successfully!";
        toast.success(successMessage);
        history.push("/about-detail");
      } else {
        toast.error("Submission failed: " + (response.data.message || ""))
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div className="main-content-inner">
      {/* <!-- main-content-wrap --> */}
      <div className="main-content-wrap">
        <div className="flex items-center flex-wrap justify-between gap20 mb-27">
          <h3>About us</h3>
          <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
            <li>
              <Link to="/">
                <div className="text-tiny">Dashboard</div>
              </Link>
            </li>
            <li>
              <i className="icon-chevron-right"></i>
            </li>
            <li>
              <div className="text-tiny">Add About Image</div>
            </li>
          </ul>
        </div>
        {/* <!-- form-add-product --> */}
        <form className="tf-section-2 form-add-product" onSubmit={handleSubmit}>
          <div className="wg-box">
            <fieldset className="name">
              <div className="body-title mb-10">
                Name <span className="tf-color-1">*</span>
              </div>
              <input
                className="mb-10"
                type="text"
                placeholder="Enter about name"
                name="name"
                value={formData.name || about_data.name || ""}
                onChange={handleChange}
                required
              />
            </fieldset>
            <fieldset className="mt-4">
              <div className="body-title mb-10">Upload Image</div>

              <input
                type="file"
                id="myFile"
                name="image"
                onChange={handleFileChange}
                accept="image/*"
                className="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 p-2"
              />

              <div className="mt-4">
                {preview ? (
                  // Preview of new selected image
                  <img
                    src={preview}
                    alt="Preview"
                    className="w-32 h-32 object-cover rounded-lg border border-gray-300"
                  />
                ) : about_data?.image ? (
                  // Existing image from backend
                  <img
                    src={`${BASE_URL}/${about_data.image}`}
                    alt="Existing"
                    className="w-32 h-32 object-cover rounded-lg border border-gray-300"
                  />
                ) : (
                  <p>No image available</p>
                )}
              </div>
            </fieldset>

            <fieldset className="description">
              <div className="body-title mb-10">
                Description <span className="tf-color-1">*</span>
              </div>
              <CKEditor
                editor={ClassicEditor}
                data={formData.description || about_data.description || ""}
                onChange={(event, editor) => {
                  const data = editor?.getData();
                  setFormData((prev) => ({ ...prev, description: data }));
                }}
              />
            </fieldset>

            <div className="cols gap10 mt-4">
              <button className="tf-button style-1 w-full" type="submit">
                Update About
              </button>
            </div>
          </div>
        </form>
        {/* <!-- /form-add-product --> */}
      </div>
      {/* <!-- /main-content-wrap --> */}
    </div>
  );
};
export default AboutDetail;
